import React from "react";
import "../Services.css";

import {
  FaLaptopCode,
  FaMobileAlt,
  FaRobot,
  FaCloud,
  FaChartLine,
  FaPalette,
  FaCogs,
  FaHeadset,
  FaArrowRight,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const services = [
  {
    icon: <FaLaptopCode />,
    title: "Custom Software Development",
    description:
      "Build secure, scalable, and high-performance software tailored to your unique business requirements.",
  },
  {
    icon: <FaMobileAlt />,
    title: "Web & Mobile Applications",
    description:
      "Develop responsive websites and powerful Android & iOS applications that deliver exceptional user experiences.",
  },
  {
    icon: <FaRobot />,
    title: "AI & Automation",
    description:
      "Leverage artificial intelligence and automation to streamline operations and unlock smarter business decisions.",
  },
  {
    icon: <FaCloud />,
    title: "Cloud Solutions",
    description:
      "Modernize your infrastructure with cloud-native applications, migration, and scalable cloud architecture.",
  },
  {
    icon: <FaChartLine />,
    title: "IT Consulting",
    description:
      "Transform your business with strategic technology consulting, digital transformation, and process optimization.",
  },
  {
    icon: <FaPalette />,
    title: "UI/UX Design",
    description:
      "Create intuitive, engaging, and user-centric digital experiences with modern interface design.",
  },
  {
    icon: <FaCogs />,
    title: "Enterprise Solutions",
    description:
      "Develop ERP, CRM, workflow automation, and enterprise-grade software to improve operational efficiency.",
  },
  {
    icon: <FaHeadset />,
    title: "Support & Maintenance",
    description:
      "Ensure long-term success with proactive monitoring, maintenance, security updates, and technical support.",
  },
];

const Services = () => {
  return (
    <section className="services">

      <div className="services-container">

        <span className="section-tag">
          OUR SERVICES
        </span>

        <h2>
          Innovative Technology Solutions
          <span> Tailored for Your Business</span>
        </h2>

        <p className="services-intro">
          At VisionVote Technologies, we combine technology, innovation, and
          strategic consulting to help organizations accelerate digital
          transformation. From software engineering to AI-powered automation,
          we deliver scalable solutions that drive measurable business growth.
        </p>

        <div className="services-grid">

          {services.map((service, index) => (
            <div className="service-card" key={index}>

              <div className="service-icon">
                {service.icon}
              </div>

              <h3>{service.title}</h3>

              <p>{service.description}</p>

              <button>
              <a href="/services" style={{ textDecoration: "none", color: "inherit", hover: { backgroundColor: "#fff", color: "#007bff" } }}>
                Learn More
                </a>
                <FaArrowRight />
              
              </button>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
};

export default Services;